export const SPOTTED_NOT_SECURED_LOADING = 'SPOTTED_NOT_SECURED/LOADING';
export const SPOTTED_NOT_SECURED_MODAL_TYPE = 'SPOTTED_NOT_SECURED/VEHICLE_MODAL';
export const SPOTTED_NOT_SECURED_STATE_TYPE = 'SPOTTED_NOT_SECURED/RESET_STATE';
export const SPOTTED_NOT_SECURED_ON_SEARCH_TYPE = 'SPOTTED_NOT_SECURED/ON_SEARCH';
export const SPOTTED_NOT_SECURED_HANDLE_SEARCH_TYPE = 'SPOTTED_NOT_SECURED/HANDLE_SEARCH';
export const SPOTTED_NOT_SECURED_ON_BRANCH_CHANGE_TYPE = 'SPOTTED_NOT_SECURED/ON_BRANCH_CHANGE';

export const FETCH_SNS_THUNK_TYPE = 'FETCH_SNS_THUNK_TYPE/FETCH_LIST';
export const FETCH_SNS_ERROR_MSG = 'Error fetching the list.';

export const CREATE_SPOTTED_NOTE_THUNK_TYPE = 'SPOTTED_NOT_SECURED/CREATE_SPOTTED_NOTE';
export const CREATE_SPOTTED_NOTE_ERROR_MSG = 'Error creating the spotted note.';

export const FETCH_SPOTTED_NOTES_THUNK_TYPE = 'SPOTTED_NOT_SECURED/FETCH_SPOTTED_NOTES';
export const FETCH_SPOTTED_NOTE_ERROR_MSG = 'Error fetching the spotted note.';

export const EDIT_SPOTTED_NOTE_THUNK_TYPE = 'SPOTTED_NOT_SECURED/EDIT_SPOTTED_NOTE';
export const EDIT_SPOTTED_NOTE_ERROR_MSG = 'Error editing the spotted note.';

export const COUNT_ORDER_TYPE_THUNK_TYPE = 'SPOTTED_NOT_SECURED/COUNT_ORDER_TYPE_THUNK_TYPE';
export const COUNT_ORDER_TYPE_ERROR_MSG = 'Error counting order types.';

export const COUNT_REACH_STATUS_THUNK_TYPE = 'SPOTTED_NOT_SECURED/COUNT_REACH_STATUS_THUNK_TYPE';
export const COUNT_REACH_STATUS_ERROR_MSG = 'Error counting reach status.';

export const COUNT_RHL_THUNK_TYPE = 'SPOTTED_NOT_SECURED/COUNT_RHL_THUNK_TYPE';
export const COUNT_RHL_ERROR_MSG = 'Error counting the records.';

export const FETCH_SNS_MAP_DATA_THUNK_TYPE = 'SPOTTED_NOT_SECURED/FETCH_RHL_MAP_DATA_THUNK_TYPE';
export const FETCH_SNS_MAP_ERROR_MSG = 'Error fetching map data.';

export const REFETCH_SNS_THUNK_TYPE = 'SPOTTED_NOT_SECURED/REFETCH_SNS_THUNK_TYPE';
export const REFETCH_SNS_ERROR_MSG = 'Error refetching data.';

export const CHANGE_COLLATERAL_COLOR_TYPE = 'SPOTTED_NOT_SECURED/CHANGE_COLLATERAL_COLOR';

export const TAKE_CASE_NOTES_AMOUNT = 2;
export const PAGINATION_TAKE_AMOUNT = 10;

export const SPOTTED_NOT_SECURED_INITIAL_STATE = {
  searchQuery: null,
  listData: [],
  vehicleModalData: null,
  mapData: null,
  vehicleModalSpottedNotesData: null,
  fetchSpottedNotesLoading: true,
  createSpottedNoteLoading: false,
  listCount: 0,
  accessibleCount: 0,
  obstructedCount: 0,
  allOrderTypeCount: 0,
  voluntaryCount: 0,
  involuntaryCount: 0,
  impoundCount: 0,
  totalCount: 0,
  skipAmount: 0,
  loading: false,
  loadingOrderTypeCounter: true,
};
